import { Component, OnInit } from '@angular/core';
import { AuthUserModel, ComponentType, Folder, HxAuthService, HxFileService, HxUiLabelPipe, StoreBasicModel, SysFilename, TableRef } from 'hx-services';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { NzCardComponent } from 'ng-zorro-antd/card';
import { DatePipe, NgFor, NgIf } from '@angular/common';
import { NzIconDirective } from 'ng-zorro-antd/icon';
import { NzTooltipDirective } from 'ng-zorro-antd/tooltip';
import { NzAvatarComponent } from 'ng-zorro-antd/avatar';
import { NzDividerComponent } from 'ng-zorro-antd/divider';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import {
  NzCellAlignDirective,
  NzTableCellDirective,
  NzTableComponent,
  NzTbodyComponent,
  NzTheadComponent,
  NzThMeasureDirective,
  NzTrDirective
} from 'ng-zorro-antd/table';
import { ProfileEditComponent } from '@profile-app/components/profile-edit/profile-edit.component';
import { PasswordChangeComponent } from '@profile-app/components/password-change/password-change.component';

interface MatrixItem {
  group: StoreBasicModel;
  componentMap: Map<ComponentType, boolean>;
}

@Component({
  selector: 'app-profile',
  templateUrl: './profile.page.html',
  styleUrls: ['./profile.page.less'],
  imports: [TranslocoDirective, NzCardComponent, NgIf, NzIconDirective, NzTooltipDirective, NzAvatarComponent, NzDividerComponent, NzRowDirective, NzColDirective, ProfileEditComponent, PasswordChangeComponent, NzTableComponent, NzTheadComponent, NzTrDirective, NzTableCellDirective, NzThMeasureDirective, NgFor, NzTbodyComponent, NzCellAlignDirective, DatePipe, HxUiLabelPipe, TranslocoPipe]
})
export class ProfilePage implements OnInit {

  user!: AuthUserModel;
  isLoading = {
    memberships: false,
    avatar: false,
  };
  matrix: MatrixItem[] = [];
  components: ComponentType[] = [];
  avatarUrl?: string;
  signExists = false;
  isEdit = false;
  passwordChange = false;

  constructor(
    public auth: HxAuthService,
    private fileService: HxFileService,
  ) {
  }

  ngOnInit() {
    this.user = this.auth.user;
    this.isLoading.memberships = true;
    if (this.user.profileId) {
      this.fileService.getFilesByRef({ref: this.user.profileId, table: TableRef.hc_profiles, folder: Folder.SYSTEM}).then(files => {
        const guid = files.find(f => f.fileName.startsWith(SysFilename.avatar))?.guid;
        if (guid) {
          this.avatarUrl = `${HxFileService.fileDownloadUrl}/${guid}`;
        }
        this.signExists = files.find(f => f.fileName.startsWith(SysFilename.sign)) !== undefined;
      });
    }

    this.auth.getMemberships({includeStore: true}).subscribe(memberships => {
      // const items = memberships.map(m => ({...m.membership, store: m.store ?? {} as StoreBasicModel}));

      const storeMap = new Map<number, {
        group: StoreBasicModel,
        componentMap: Map<ComponentType, boolean>
      }>();
      const components = new Set<ComponentType>();
      memberships.forEach(item => {
        if (item.group && !item.membership.components.includes(ComponentType.profile)) {
          const matrixItem = storeMap.get(item.group.id) ?? {group: item.group, componentMap: new Map<ComponentType, boolean>()};
          item.membership.components.forEach(component => {
            matrixItem.componentMap.set(component, item.membership.enabled);
            components.add(component);
          });
          storeMap.set(item.group.id, matrixItem);
        }
      });
      const componentArr = Array.from(components);
      componentArr.sort((a, b) => a.localeCompare(b));
      this.components = componentArr;
      this.matrix = Array.from(storeMap.values());
      this.isLoading.memberships = false;
    }, err => this.isLoading.memberships = false);
  }

  onBackClicked() {
    this.isEdit = false;
    this.passwordChange = false;
  }

  editProfile() {
    this.isEdit = true;
  }

  async onProfileSaved() {
    this.user = await this.auth.getIdentity();
    this.auth.setAuthUser(this.user);
    this.isEdit = false;
  }

  editPassword() {
    this.passwordChange = true;
  }

  onPasswordChanged() {
    this.passwordChange = false;
  }
}
